import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "stdio" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "stdio__prompt" }, "> ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "stdio__caret" }, null, -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "stdio__input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.entry) = $event)),
      type: "text",
      autocapitalize: "off",
      autocomplete: "off",
      ref: "activeInput",
      onKeydown: [
        _cache[1] || (_cache[1] = (...args) => ($options.onKeyDown && $options.onKeyDown(...args))),
        _cache[2] || (_cache[2] = _withKeys(_withModifiers((...args) => ($options.submitEntry && $options.submitEntry(...args)), ["prevent"]), ["enter"]))
      ]
    }, null, 544), [
      [_vModelText, $data.entry]
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.history, (line, lineIdx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "stdio__line",
        key: lineIdx
      }, [
        (!line.input)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(line.message), 1))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (!line.any)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_3,
                    ($props.inputting && lineIdx === $props.history.length - 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString($data.entry), 1),
                          _hoisted_4
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(line.entry), 1))
                  ], 64))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, "Press any key to continue."))
            ], 64))
      ]))
    }), 128))
  ]))
}